<template>
  <section class="match-reward-cash-section">
    <div class="cash-brush" aria-hidden="true"></div>

    <div class="cash-title">
      <img :src="cashPrizeData.titleImage" alt="现金大奖" />
    </div>

    <div class="cash-description">
      <div class="cash-description-centered">
        <div v-for="line in cashPrizeData.centeredDescription" :key="line">{{ line }}</div>
      </div>
      <div class="cash-description-prize">
        <div v-for="line in cashPrizeData.prizeDescription" :key="line">{{ line }}</div>
      </div>
    </div>

    <div class="cash-prize-image">
      <img :src="cashPrizeData.prizeImage" alt="现金大奖奖励" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'MatchRewardCashPrizeSection',
  props: {
    cashPrizeData: { type: Object, required: true },
  },
}
</script>

<style scoped lang="scss">
.match-reward-cash-section {
  position: relative;
  padding-bottom: 0.84375rem;

  .cash-brush {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 7.708333rem;
    opacity: 1;
    background: url('@/assets/image/match/pc/match/reward-brush-overlay.png') center top / 100% 100% no-repeat;
    pointer-events: none;
  }

  .cash-title,
  .cash-description,
  .cash-prize-image {
    position: relative;
    z-index: 1;
    margin-right: auto;
    margin-left: auto;
  }

  .cash-title {
    width: 6.880208rem;
    height: 0.875rem;

    img {
      display: block;
      width: 6.880208rem;
      height: 0.875rem;
    }
  }

  .cash-description {
    margin-top: 0.333333rem;
    color: #773700;
    font-size: 0.145833rem;
    font-weight: 700;
    line-height: 0.25rem;
    text-align: center;

    .cash-description-centered {
      text-align: center;
      width: 80%;
      margin: 0 auto;
    }

    .cash-description-prize {
      display: inline-block;
      max-width: 100%;
      text-align: left;

      >div:last-child {
        text-align: center;
      }
    }

    .cash-description-centered>div,
    .cash-description-prize>div {
      min-height: 0.25rem;
      height: auto;
      line-height: 0.25rem;
      overflow-wrap: break-word;
    }

    .cash-description-centered>div+div,
    .cash-description-prize>div+div {
      margin-top: 0.03125rem;
    }
  }

  .cash-prize-image {
    width: 7.291667rem;
    height: 4.473958rem;
    margin-top: 0.182292rem;

    img {
      display: block;
      width: 7.291667rem;
      height: 4.473958rem;
    }
  }
}

@media (max-width: 750px) {
  .match-reward-cash-section {
    padding-bottom: 10vw;

    .cash-brush {
      display: none;
    }

    .cash-title {
      width: 90%;
      height: auto;
      margin-top: 30vw;

      img {
        width: 100%;
        height: auto;
      }
    }

    .cash-description {
      width: 94vw;
      margin-top: 3.5vw;
      font-size: 3.2vw;
      line-height: 5.8vw;

      .cash-description-centered>div,
      .cash-description-prize>div {
        height: auto;
        line-height: 5.8vw;
      }

      .cash-description-centered {
        width: auto;

        >div:last-child {
          text-align: left;
        }
      }
    }

    .cash-prize-image {
      width: 96%;
      height: auto;
      margin-top: 3vw;

      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
